<script>
import { ValidationObserver } from 'vee-validate';
export default {
  name: 'custom-validation-observer',
  extends: ValidationObserver,
  watch: {
    // for fixStickyContainer (fixing position of a floating button next step on valid observer)
    'flags.valid': {
      immediate: true,
      handler (val) {
        if (val) this.$emit('valid');
      },
    },
  },
};
</script>
